import { render } from "./BreadcrumbItem.vue?vue&type=template&id=69e0c181&scoped=true"
import script from "./BreadcrumbItem.vue?vue&type=script&lang=js"
export * from "./BreadcrumbItem.vue?vue&type=script&lang=js"

import "./BreadcrumbItem.vue?vue&type=style&index=0&id=69e0c181&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e0c181"]])

export default __exports__